import { centeredFlex } from 'core/styles';
import { paddings, typographyDesktop } from 'core/styles/variables';
import styled from 'styled-components';

export const LoaderWrapper = styled.div`
  ${centeredFlex};
`;
export const CallbackWrapper = styled.div`
  width: 100%;
`;

export const ErrorSpan = styled.div`
  color: ${({ theme }) => theme.colors.red500};
  font-size: ${typographyDesktop.size.small};
  padding-top: ${paddings.smallPadding};
  width: 100%;
`;

export const SalesCompanyCodesWrapper = styled.div`
  font-size: ${typographyDesktop.size.tiny};
  position: relative;
  top: ${paddings.smallPadding};
  right: 0;
`;
